<template>
    <div class="checkout-step-cart col-xs-12 ph0-ns" v-bind:class="{ opened: open }">
        <div v-if="empty === true && loading === false" v-bind:class="{ empty: empty === true }">{{ strings['empty_cart'] }}</div>
        <div v-if="empty === false && loading === false">
            <div class="cart-items-list row">
                <div class="col-sm-12">
                    <cart-item
                        v-for="(product, key) in cart.items"
                        v-bind:product="product"
                        v-bind:currency="cart.currency"
                        v-bind:strings="strings"
                        v-bind:key="key"
                        v-bind:recap="false"
                        v-on:add="$emit('update-item', key, 'add')"
                        v-on:remove="$emit('update-item', key, 'remove')"
                        v-on:delete="$emit('delete-item', key)"
                    ></cart-item>
                </div>
            </div>
            <div class="cart-totals-subtotal row">
                <div class="col-sm-7"></div>
                <div class="col-sm-5">
                    <div class="row tnumbers">
                        <div class="col-xs-6">{{ strings['subtotal'] }}</div>
                        <div class="col-xs-6  text-right">{{ cart.currency }} {{ cart.subtotal.toFixed(2) }}</div>
                    </div>
                </div>
            </div>
            <div class="cart-totals-subtotal row" v-if="cart.subtotalPromo > 0">
                <div class="col-sm-7"></div>
                <div class="col-sm-5">
                    <div class="row tnumbers">
                        <div class="col-xs-6">{{ strings['promo_discount_label'] }}</div>
                        <div class="col-xs-6 text-right">{{ cart.currency }} - {{ cart.subtotalPromo.toFixed(2) }}</div>
                    </div>
                </div>
            </div>
            <div class="cart-totals-shipping-cost row">
                <div class="col-sm-7"></div>
                <div class="col-sm-5">
                    <div class="row tnumbers">
                        <div class="col-xs-6">{{ strings['shipping_cost'] }}<div class="change-country">({{ cart.country.name }})</div></div>
                        <div class="col-xs-6  text-right">
                            <div v-if="cart.shippingCostPromo != null" class="shipping-promo">{{ cart.currency }} {{ cart.shippingCostPromo.toFixed(2) }}</div>
                            {{ cart.currency }} {{ cart.shippingCost.toFixed(2) }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="cart-divider mv3 pa0"></div>
            <div class="cart-totals-total row">
                <div class="col-sm-9 col-xs-12">
                    <div class="cart-totals-promo">
                        <div class="promo-input flex flex-column flex-row-ns items-center">
                            <div v-if="cart.promoCheck">
                                <span class="mb2 mb0-ns">{{ strings['coupon'] }} {{ cart.promoCode }} &nbsp;&nbsp;</span><button v-on:click="$emit('delete-promo')" class="cart-totals-promo-remove bttn ttu mb3 mb0-ns"><i class="far fa-times"></i> &nbsp;{{ strings['remove_coupon'] }} </button>
                            </div>
                            <div v-else>
                                <span>{{ strings['promo_label'] }}</span> <input type="text" id="promoCode" v-bind:value="cart.promoCode" @input="cart.promoCode = $event.target.value.toUpperCase()" class="mh2 mt3 mt0-ns"><button v-on:click="$emit('add-promo', cart.promoCode)" class="cart-totals-promo-submit bttn ttu mb3 mb0-ns">{{ strings['update'] }} <i class="far fa-spinner-third fa-spin"></i></button>
                            </div>
                        </div>
                        <div class="cart-totals-promo-error">
                            <i class="fa fa-exclamation-triangle"></i> <span class="cart-totals-promo-error-msg">Errore Promozione</span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3 col-xs-12 tnumbers text-right">
                    <span class="pt2 pr3">{{ strings['total'] }}</span><span class="pt2">{{ cart.currency }} {{ cart.total.toFixed(2) }}</span>
                </div>
            </div>
            <div class="row tr" v-if="shippingrussian === true">
                <div class="col-xs-12 tc mb5 mt3">
                    <div class="pa3" style="background-color: white" v-html="strings['shipping_russian']"></div>
                </div>
            </div>
            <div class="row tr" v-if="cart.scalapay === true">
                <div class="col-xs-12">
                    <scalapay-widget v-bind:amount="cart.total.toFixed(2)"  min="35" alignment="right"  v-bind:locale="lang" number-of-installments="4"></scalapay-widget>
                </div>
            </div>
            <div class="row" v-if="activebuy == false">
                <div class="col-xs-12 tc mb5 mt3">
                    <div class="pa3" style="background-color: white">
                        <h3><b>{{ strings['minimum_order_gb'] }}</b></h3>
                    </div>
                </div>
            </div>
            <div class="cart-totals-actions row" v-else>
                <div v-if="forbiddenproducts == true">
                    <div class="tnumbers">
                        <div class="form-group">
                            <p style="padding:5px;background:#303030;color:white;text-align:center;">{{ strings['forbidden_order'] }}</p>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="tnumbers col-xs-12 mt3">
                        <a v-bind:href="api['summary']" class="bttn tc w-100 ttu">{{ strings['go_to_checkout'] }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center" v-if="loading === true">
            <div class="loader">Loading...</div>
        </div>
        <div class="cart-items-loading" v-bind:class="{ opened: loadingpage === true }">
            <div class="flex justify-center content-center items-center">
                <div><b>Updating...</b></div>
            </div>
        </div>
    </div>
</template>

<script>
import CartPageItem from './CartPageItem.vue'

export default {
    props: [
        'open',
        'strings',
        'empty',
        'cart',
        'api',
        'loading',
        'loadingpage',
        'activebuy',
        'forbiddenproducts',
        'lang',
        'shippingrussian'
    ],
    components: {
        'cart-item': CartPageItem,
    }
}
</script>
